import { Drawer } from "@/components";
import { DRAWER_BLOCKED_USERS } from "@/const";
import { AmityAuthProvider } from "@/providers";
import { useResponsiveness, useTranslate } from "@/providers/context";

import { CommunityBlockedUsers } from "./CommunityBlockedUsers";

export const BlockedUsersDrawer = () => {
  const { translate } = useTranslate();
  const { openDrawer, setOpenDrawer } = useResponsiveness();

  return (
    <Drawer
      title={translate("Blocked Users")}
      open={openDrawer === DRAWER_BLOCKED_USERS}
      onOpenChange={(open) => setOpenDrawer(open ? DRAWER_BLOCKED_USERS : "")}
    >
      <AmityAuthProvider>
        <CommunityBlockedUsers />
      </AmityAuthProvider>
    </Drawer>
  );
};
